export const state = {
  selectedDos: [],
  customer: {},
  products: [],
  generalInfo: {}
}

export const mutations = {
  setSelectedDos(state, payload) {
    state.selectedDos = payload
  },
  setCustomer(state, payload) {
    state.customer = payload
  },
  setProducts(state, payload) {
    state.products = payload
  },
  setGeneralInfo(state, payload) {
    state.generalInfo = payload
  }
}